export default class ContextMenu {
  constructor(defs) {
    this._defs = defs;
    this._target = null;
    
    this._elList = document.createElement('ul');
    this._elList.classList.add('contextMenu', 'hidden');
    for(const label in defs) {
      const def = defs[label];
      const li = document.createElement('li');
      li.textContent = label;
      li.setAttribute('data-orgtxt', label);
      this._elList.appendChild(li);
      def.element = li;
      if(!('check' in def)) {
        def.check = () => true;
      }
    }
    this._elList.addEventListener('click', e => {
      if(e.target.nodeName === 'LI') {
        this._defs[e.target.getAttribute('data-orgtxt')].execute(this._target);
        this._hide();
      }
    });
    document.body.appendChild(this._elList);

    window.addEventListener('mousedown', e => {
      if(e.target.parentElement !== this._elList) this._hide()
    });
  }
  get elList() {
    return this._elList;
  }
  show(cursorX, cursorY, target = null) {
    const {width, height} = this._elList.getBoundingClientRect();
    let x, y;
    if(cursorX < window.innerWidth / 2) {
      x = cursorX;
    } else {
      x = cursorX - width;
    }
    if(cursorY < window.innerHeight / 2) {
      y = cursorY;
    } else {
      y = cursorY - height;
    }
    this._elList.style.left = x + 'px';
    this._elList.style.top = y + 'px';
    this._elList.classList.remove('hidden');
    this._target = target;
    for(const label in this._defs) {
      const def = this._defs[label];
      if(def.check(target)) {
        def.element.classList.remove('disabled');
      } else {
        def.element.classList.add('disabled');
      }
    }
    document.body.classList.add('dontTouchCuzContextMenu');
  }
  _hide() {
    this._elList.classList.add('hidden');
    document.body.classList.remove('dontTouchCuzContextMenu');
  }
}
